module.exports = __webpack_public_path__ + "static/media/gd.8e690a5a.svg";